import { moduleIds } from '@/hooks/useFeatures';
import React from 'react';

const SUPPORT_PORTAL_URL =
  process.env.REACT_APP_SUPPORT_PORTAL_URL || 'https://support.prodaff.com/';

export const teamReportItems = [
  {
    id: 'dashboard-overview',
    moduleId: moduleIds.DASHBOARD_OVERVIEW,
    title: 'Users Dashboard',
    type: 'item',
    navLink: '/dashboard-overview',
  },

  {
    id: 'alerts',
    moduleId: moduleIds.PRODUCTIVITY_ALERT,
    title: 'Productivity Alert',
    type: 'item',
    navLink: '/alerts',
  },
  // {
  //   id: "team-dashboard",
  //   title: "Team",
  //   type: "item",
  //   navLink: "/dashboard-team",
  // },
  // {
  //   id: "user-dashboard",
  //   title: "User",
  //   type: "item",
  //   navLink: "/dashboard-individual",
  // },
  {
    id: 'timeline',
    moduleId: moduleIds.TIMELINE,
    title: 'Timeline',
    type: 'item',
    navLink: '/timeline',
  },
  {
    id: 'screenshots',
    moduleId: moduleIds.SCREENSHOTS,
    title: 'Screenshots',
    type: 'item',
    navLink: '/screenshots',
  },
  {
    id: 'app-usage',
    moduleId: moduleIds.APP_USAGE,
    title: 'App Usage',
    type: 'item',
    navLink: '/app-usage',
  },
  {
    id: 'teams-timeline',
    moduleId: moduleIds.TEAMS_TIMELINE,
    title: "Department's Timeline",
    type: 'item',
    navLink: '/teams-timeline',
  },
  {
    id: 'teams-reporting',
    moduleId: moduleIds.TEAMS_REPORTING,
    title: "Department's Reporting",
    type: 'item',
    navLink: '/teams-reporting',
  },
  // {
  //   id: "team-attendance",
  //   title: "Team Attendance",
  //   type: "item",
  //   navLink: "/team-attendance",
  //
  // },
  {
    id: 'user-attendance',
    moduleId: moduleIds.USER_ATTENDANCE,
    title: 'User Attendance',
    type: 'item',
    navLink: '/userAttendance',
  },
  {
    id: 'notifications',
    moduleId: moduleIds.NOTIFICATIONS,
    title: 'Notifications',
    type: 'item',
    navLink: '/notifications',
  },
];
export const managementItems = [
  {
    id: 'regularization',
    moduleId: moduleIds.REGULARIZATION,
    title: 'Regularization',
    type: 'item',
    navLink: '/regularization',
  },
  {
    id: 'requests',
    moduleId: moduleIds.REQUESTS_REGULARIZATION,
    title: 'Regularization requests',
    type: 'item',
    navLink: '/requestsregularization',
  },
  {
    id: 'leave',
    moduleId: moduleIds.LEAVE,
    title: 'Leave',
    type: 'item',
    navLink: '/leave',
  },
  {
    id: 'leaverequest',
    moduleId: moduleIds.LEAVE_REQUESTS,
    title: 'Leave requests',
    type: 'item',
    navLink: '/requestsleave',
  },
  {
    id: 'profile',
    title: 'Profile',
    type: 'item',
    navLink: '/profile',
  },
  {
    id: 'settings',
    moduleId: moduleIds.SETTINGS,
    title: 'Settings',
    type: 'item',
    navLink: '/manage-settings',
  },
  {
    id: 'billing',
    title: 'Invoices',
    type: 'item',
    navLink: '/invoices',
  },
  // {
  //   id: "clients",
  //   title: "Clients",
  //   type: "item",
  //   navLink: "/manage-clients",
  //
  // },
  {
    id: 'projects',
    moduleId: moduleIds.PROJECTS,
    title: 'Projects',
    type: 'item',
    navLink: '/project',
  },
  {
    id: 'tasks',
    moduleId: moduleIds.TASKS,
    title: 'Tasks',
    type: 'item',
    navLink: '/manage-tasks',
  },
  {
    id: 'add-employee',
    moduleId: moduleIds.ADD_EMPLOYEE,
    title: 'Add Employee',
    type: 'item',
    navLink: '/add-employee',
  },
  {
    id: 'employee-list',
    moduleId: moduleIds.EMPLOYEE_LIST,
    title: 'Employee List',
    type: 'item',
    navLink: '/employee-list',
  },
  {
    id: 'team-list',
    moduleId: moduleIds.TEAM_LIST,
    title: 'Department List',
    type: 'item',
    navLink: '/team-list',
  },
  {
    id: 'invitations-hub',
    moduleId: moduleIds.INVITATIONS,
    title: 'Invitations',
    type: 'item',
    navLink: '/invitations-hub',
  },
  {
    id: 'integrations',
    title: 'Integrations',
    type: 'item',
    navLink: '/integrations',
  },
  {
    id: 'download-desktop-app',
    title: 'App Downloads',
    type: 'item',
    navLink: '/download-desktop-app',
  },
  {
    id: 'support-portal',
    title: 'Support',
    type: 'item',
    external: true,
    navLink: SUPPORT_PORTAL_URL,
  },
];
